import { Icon, Tooltip, Typography } from '@lightbeamai/design-system'
import './radioView.less'
import React from 'react'

interface IProps {
  checked: boolean
  content: React.ReactNode
  tooltip?: React.ReactNode
  disabled?: boolean
  className?: string
  testContext?: string
  onClick: (checked: boolean) => void
}

const RadioView = (props: IProps) => {
  const {
    checked,
    content,
    tooltip,
    disabled = false,
    className = '',
    testContext,
    onClick
  } = props

  const handleClick = () => !disabled && onClick(!checked)

  return (
    <div
      className={`radio-custom ${disabled ? 'disabled' : ''} ${className}`}
      onClick={handleClick}
      data-test-id="radio-view"
      {...(testContext ? { 'data-test-context': testContext } : {})}
    >
      <div className={`checkbox ${checked ? 'checked' : ''}`}>
        {checked && <div className="selection" />}
      </div>
      <div className="align-center">
        <Typography as="div" color="primary" variant="base" className="label">
          {content}
        </Typography>
        {tooltip && (
          <Tooltip title={tooltip} placement="top" arrow>
            <Icon name="InfoCircle" size={16} color="" className="xs-ml-4" />
          </Tooltip>
        )}
      </div>
    </div>
  )
}

export default RadioView
